/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EmailDto } from './EmailDto';
import {
    EmailDtoFromJSON,
    EmailDtoFromJSONTyped,
    EmailDtoToJSON,
} from './EmailDto';
import type { TelephoneDto } from './TelephoneDto';
import {
    TelephoneDtoFromJSON,
    TelephoneDtoFromJSONTyped,
    TelephoneDtoToJSON,
} from './TelephoneDto';

/**
 * 
 * @export
 * @interface UserEditProfileDto
 */
export interface UserEditProfileDto {
    /**
     * 
     * @type {number}
     * @memberof UserEditProfileDto
     */
    iduser?: number;
    /**
     * 
     * @type {number}
     * @memberof UserEditProfileDto
     */
    idpersonne?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserEditProfileDto
     */
    codesexe?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEditProfileDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEditProfileDto
     */
    prenom?: string | null;
    /**
     * 
     * @type {TelephoneDto}
     * @memberof UserEditProfileDto
     */
    telephone?: TelephoneDto;
    /**
     * 
     * @type {TelephoneDto}
     * @memberof UserEditProfileDto
     */
    gsm?: TelephoneDto;
    /**
     * 
     * @type {EmailDto}
     * @memberof UserEditProfileDto
     */
    email?: EmailDto;
    /**
     * 
     * @type {boolean}
     * @memberof UserEditProfileDto
     */
    notifySuiviHope?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserEditProfileDto
     */
    notifySuiviSmile?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserEditProfileDto
     */
    notifySuiviObserver?: boolean | null;
}

/**
 * Check if a given object implements the UserEditProfileDto interface.
 */
export function instanceOfUserEditProfileDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserEditProfileDtoFromJSON(json: any): UserEditProfileDto {
    return UserEditProfileDtoFromJSONTyped(json, false);
}

export function UserEditProfileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserEditProfileDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iduser': !exists(json, 'iduser') ? undefined : json['iduser'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'codesexe': !exists(json, 'codesexe') ? undefined : json['codesexe'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'telephone': !exists(json, 'telephone') ? undefined : TelephoneDtoFromJSON(json['telephone']),
        'gsm': !exists(json, 'gsm') ? undefined : TelephoneDtoFromJSON(json['gsm']),
        'email': !exists(json, 'email') ? undefined : EmailDtoFromJSON(json['email']),
        'notifySuiviHope': !exists(json, 'notifySuiviHope') ? undefined : json['notifySuiviHope'],
        'notifySuiviSmile': !exists(json, 'notifySuiviSmile') ? undefined : json['notifySuiviSmile'],
        'notifySuiviObserver': !exists(json, 'notifySuiviObserver') ? undefined : json['notifySuiviObserver'],
    };
}

export function UserEditProfileDtoToJSON(value?: UserEditProfileDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iduser': value.iduser,
        'idpersonne': value.idpersonne,
        'codesexe': value.codesexe,
        'nom': value.nom,
        'prenom': value.prenom,
        'telephone': TelephoneDtoToJSON(value.telephone),
        'gsm': TelephoneDtoToJSON(value.gsm),
        'email': EmailDtoToJSON(value.email),
        'notifySuiviHope': value.notifySuiviHope,
        'notifySuiviSmile': value.notifySuiviSmile,
        'notifySuiviObserver': value.notifySuiviObserver,
    };
}

